import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/lazy-img/style/index.tsx